<!-- Header da Pagina (oculto no modo embutido: o Operar Cliente já tem o seu) -->
<div class="page-header" *ngIf="!embutido">
  <div class="header-icon">
    <i class="pi pi-th-large"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView -->
<div class="tabs-container" [class.embutido]="embutido">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-tag"></i>
          </div>
          <span class="card-header-title">{{ texts.dados_do_grupo }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <div class="form-field half">
              <label class="form-label">{{ labels.nome }} <span class="required">*</span></label>
              <input type="text" pInputText [(ngModel)]="form.nome"
                [placeholder]="placeholders.nome"
                [class.error-field]="isFormSubmitted && !form.nome"
                class="w-full" />
            </div>
            <div class="form-field full">
              <label class="form-label">{{ labels.imagem }}</label>
              <p-fileUpload #fileUploader name="grupo" [multiple]="false" accept="image/*" [maxFileSize]="2000000"
                [showUploadButton]="false" [showCancelButton]="true"
                [chooseLabel]="botoes.selecionarImagem"
                [cancelLabel]="botoes.remover" (onSelect)="onSelectImage($event)"
                (onClear)="onClearImage()">
              </p-fileUpload>

              <!-- Pre-visualizacao + nome do arquivo -->
              <div class="image-preview" *ngIf="imagePreviewUrl">
                <img [src]="imagePreviewUrl" class="preview-image" alt="Pre-visualizacao" />
                <small class="filename">{{ fileName }}</small>
                <button pButton icon="pi pi-trash" [label]="botoes.remover"
                  class="p-button-danger p-button-sm p-button-text"
                  (click)="onClearImage()"></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparForm()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.adicionar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.salvar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="salvarEdicaoDeGrupo()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.tabelaDeGrupos }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.novo_grupo" icon="pi pi-plus"
              (click)="novoGrupo()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de pesquisa + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchNome"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="grupos" [loading]="loading"
            (sortFunction)="customSort($event)" [customSort]="true"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('imagem')" style="width: 8%">
                  {{ tabela.imagem }}
                </th>
                <th [hidden]="!isColumnVisible('codigoGrupo')" pSortableColumn="codigoGrupo" style="width: 12%">
                  {{ tabela.codigoGrupo }}<p-sortIcon [field]="'codigoGrupo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 30%">
                  {{ tabela.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('status')" pSortableColumn="status" style="width: 15%">
                  {{ tabela.status }}<p-sortIcon [field]="'status'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 20%">
                  {{ tabela.dataInclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 13%">{{ tabela.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-grupo>
              <tr>
                <td [hidden]="!isColumnVisible('imagem')" class="text-center">
                  <img *ngIf="grupo.imagem" [src]="getImagemUrl(grupo.imagem)"
                    class="grupo-thumbnail grupo-thumbnail-clickable" alt="{{ grupo.nome }}"
                    (click)="abrirImagemAmpliada(grupo)"
                    (error)="onImageError($event)" />
                  <i *ngIf="grupo.imagem" class="pi pi-image grupo-thumbnail-placeholder" style="display: none"></i>
                  <i *ngIf="!grupo.imagem" class="pi pi-image grupo-thumbnail-placeholder"></i>
                </td>
                <td [hidden]="!isColumnVisible('codigoGrupo')">{{ grupo.codigoGrupo }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ grupo.nome }}</td>
                <td [hidden]="!isColumnVisible('status')">
                  <span class="status-badge" [ngClass]="grupo.status ? 'status-ativo' : 'status-inativo'">
                    {{ grupo.status ? botoes.ativo : botoes.inativo }}
                  </span>
                </td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(grupo.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <p-inputSwitch [(ngModel)]="grupo.status"
                    (onChange)="alternarStatus(grupo)"
                    class="status-switch-table"
                    [pTooltip]="grupo.status ? botoes.ativo : botoes.inativo"
                    tooltipPosition="top">
                  </p-inputSwitch>
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarGrupo(grupo)"></button>
                  <button *ngIf="!embutido" pButton icon="pi pi-share-alt"
                    class="p-button-text p-button-rounded p-button-sm"
                    [disabled]="!podeCompartilharCategoria(grupo)"
                    [pTooltip]="podeCompartilharCategoria(grupo) ? tooltips.compartilhar : tooltips.compartilhar_indisponivel"
                    tooltipPosition="top"
                    [attr.aria-label]="tooltips.compartilhar"
                    (click)="compartilharCategoria(grupo)"></button>
                  <button *ngIf="!embutido" pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarGrupo(grupo.id)"></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhumGrupo }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Dialog de Visualizacao Ampliada da Imagem -->
<p-dialog
  [(visible)]="imagemAmpliadaVisible"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [showHeader]="true"
  [header]="imagemAmpliadaNome"
  styleClass="dialog-imagem-ampliada"
  [style]="{ width: 'auto', maxWidth: '90vw' }">
  <div class="imagem-ampliada-container">
    <img *ngIf="imagemAmpliadaSrc" [src]="imagemAmpliadaSrc"
      [alt]="imagemAmpliadaNome" class="imagem-ampliada" />
  </div>
</p-dialog>

<!-- Dialog de Confirmação de Exclusão (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  (onShow)="onDeleteDialogShow()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmarExclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar + ' (Esc)'" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button #deleteConfirmBtn pButton [label]="botoes.confirmar + ' (Enter)'" severity="danger" icon="pi pi-trash"
      style="gap: 0.35rem"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<p-toast />
